import { Play, Workflow } from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { flowsWeb } from '../web-manifest.js';

export default createWebRegistrationFromManifest(
  flowsWeb,
  {
    AutomationAliasRedirect: () => import('./AutomationAliasRedirect'),
    FlowReplaysIndexRedirect: () => import('./FlowReplaysIndexRedirect'),
    FlowsPage: () => import('./FlowsPage'),
    FlowDetailPage: () => import('./FlowDetailPage'),
    FlowEditorPage: () => import('./FlowEditorPage'),
    FlowRunPage: () => import('./FlowRunPage'),
    FlowReplayDetailPage: () => import('./FlowReplayDetailPage'),
    FlowReplaysTabContent: () => import('./FlowReplaysTabContent'),
    FlowPreview: () => import('./FlowPreview').then((m) => ({ default: m.FlowPreview })),
    FlowsPagePreview: () =>
      import('./FlowsPagePreview').then((m) => ({ default: m.FlowsPagePreview })),
  },
  {
    icons: { Play, Workflow },
  },
);
